import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ISharedContent } from '../model/share-content.model';

@Injectable({
  providedIn: 'root'
})
export class ShareContentService {
  private _sharedContent$: BehaviorSubject<ISharedContent | null> = new BehaviorSubject<ISharedContent | null>(null);


  public get sharedContent(): Observable<ISharedContent | null> {
    return this._sharedContent$.asObservable();
  }


  public set sharedContent(data: ISharedContent) {
    this._sharedContent$.next(data);
  }

}
